let scopeOfPractice = {
    title: ''
};

export default scopeOfPractice;